import * as React from 'react';

import { IDriverset } from '../../../api/models';
import { DriversetList } from './DriversetList';
import { DriversetAdd } from './DriversetAdd';
import { DriversetEdit } from './DriversetEdit';

interface IProps {
  driversets: IDriverset[];
  onChange: (driversets: IDriverset[]) => void;
}

const DriversetManager = (props: IProps) => {
  const [mode, setMode] = React.useState<'list' |'add' | 'edit'>('list');
  const [driverset, setDriverset] = React.useState<IDriverset | null>(null);

  // IDriverDate.day is nullable while editing — sort with nulls last to keep
  // them visible at the bottom of the list.
  const sortByDay = (a: { day: number | null }, b: { day: number | null }) =>
    (a.day ?? Infinity) - (b.day ?? Infinity);

  const handleSelect = (ds: IDriverset) => {
    setDriverset(ds);
    setMode('edit');
  }

  const handleAdd = (newDriverset: IDriverset) => {
    setMode('list');
    newDriverset = { ...newDriverset, dates: [...newDriverset.dates].sort(sortByDay) };
    props.onChange([ ...props.driversets, newDriverset ]);
  }

  const handleEdit = (updatedDriverset: IDriverset) => {
    updatedDriverset = { ...updatedDriverset, dates: [...updatedDriverset.dates].sort(sortByDay) };
    props.onChange([...props.driversets.filter(ds => ds !== driverset), updatedDriverset ]);
    setMode('list');
  }

  const handleDelete = () => {
    setMode('list');
    props.onChange(props.driversets.filter(ds => ds !== driverset));
  }

  return (
    <>
      <DriversetList 
        driversets={props.driversets}
        onAdd={() => setMode('add')}
        onSelect={handleSelect}
      />    
      {mode === 'add' && 
        <DriversetAdd
          onCancel={() => setMode('list')}
          onSave={handleAdd}
        />}
      {mode === 'edit' && driverset &&
        <DriversetEdit
          driverset={driverset}
          onCancel={() => setMode('list')}
          onDelete={handleDelete}
          onSave={handleEdit}
        />}
    </>
  )
}

export { DriversetManager }
